var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 13,
    viewBox: "0 0 103 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ABOUT US"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M100.845 3.4205H102.538C102.487 1.55686 100.839 0.20459 98.4756 0.20459C96.1404 0.20459 94.3506 1.53982 94.3506 3.5455C94.3506 5.16482 95.5097 6.11368 97.379 6.61936L98.754 6.99436C99.9983 7.32391 100.959 7.733 100.959 8.76709C100.959 9.90345 99.8733 10.6535 98.379 10.6535C97.0267 10.6535 95.9017 10.0512 95.7994 8.78414H94.0381C94.1517 10.8921 95.7824 12.1932 98.3904 12.1932C101.123 12.1932 102.697 10.7557 102.697 8.78414C102.697 6.68754 100.828 5.87505 99.3506 5.51141L98.2142 5.21595C97.3051 4.983 96.0949 4.55686 96.1006 3.44323C96.1006 2.45459 97.004 1.72164 98.4358 1.72164C99.771 1.72164 100.72 2.34664 100.845 3.4205Z",
    fill: "#232536"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M87.1841 0.36377V7.87513C87.1841 9.45468 86.0932 10.591 84.3205 10.591C82.5534 10.591 81.4568 9.45468 81.4568 7.87513V0.36377H79.7012V8.01718C79.7012 10.4604 81.5307 12.1933 84.3205 12.1933C87.1103 12.1933 88.9455 10.4604 88.9455 8.01718V0.36377H87.1841Z",
    fill: "#232536"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M58.4707 1.87513H62.0957V12.0001H63.8457V1.87513H67.4764V0.36377H58.4707V1.87513Z",
    fill: "#232536"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M51.731 0.36377V7.87513C51.731 9.45468 50.6401 10.591 48.8674 10.591C47.1003 10.591 46.0037 9.45468 46.0037 7.87513V0.36377H44.248V8.01718C44.248 10.4604 46.0776 12.1933 48.8674 12.1933C51.6571 12.1933 53.4924 10.4604 53.4924 8.01718V0.36377H51.731Z",
    fill: "#232536"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M39.0591 6.18186C39.0591 2.46027 36.8319 0.20459 33.8205 0.20459C30.7978 0.20459 28.5762 2.46027 28.5762 6.18186C28.5762 9.89777 30.7978 12.1591 33.8205 12.1591C36.8319 12.1591 39.0591 9.90345 39.0591 6.18186ZM37.3205 6.18186C37.3205 9.01709 35.8205 10.5569 33.8205 10.5569C31.8148 10.5569 30.3205 9.01709 30.3205 6.18186C30.3205 3.34664 31.8148 1.80686 33.8205 1.80686C35.8205 1.80686 37.3205 3.34664 37.3205 6.18186Z",
    fill: "#232536"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.4824 12.0001H19.9426C22.6472 12.0001 23.8688 10.6535 23.8688 8.86945C23.8688 7.06832 22.6074 6.05127 21.454 5.98877V5.87513C22.5222 5.60241 23.4142 4.87513 23.4142 3.42059C23.4142 1.699 22.2211 0.36377 19.7438 0.36377H15.4824V12.0001ZM17.2381 10.4945V6.76718H19.8347C21.2438 6.76718 22.1245 7.67627 22.1245 8.78422C22.1245 9.7615 21.4597 10.4945 19.7722 10.4945H17.2381ZM17.2381 5.39786V1.85809H19.6358C21.0279 1.85809 21.6926 2.59104 21.6926 3.55695C21.6926 4.68195 20.7722 5.39786 19.5904 5.39786H17.2381Z",
    fill: "#232536"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M2.26207 12.0001L3.33026 8.92059H7.87571L8.93821 12.0001H10.8018L6.61435 0.36377H4.58594L0.398438 12.0001H2.26207ZM3.84162 7.44332L5.55753 2.47741H5.64844L7.36435 7.44332H3.84162Z",
    fill: "#232536"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutus);
export default __webpack_public_path__ + "static/media/ABOUT US.95ad13b73ed04332438cb323faed871b.svg";
export { ForwardRef as ReactComponent };